import { render, staticRenderFns } from "./CheckInFooterGuest.vue?vue&type=template&id=afb5fbbc&"
import script from "./CheckInFooterGuest.vue?vue&type=script&lang=js&"
export * from "./CheckInFooterGuest.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports